<script>
  import Main from './Main.svelte'
  export let name
</script>

<Main />

<style>
  @import url('https://fonts.googleapis.com/css2?family=Montserrat:ital@0;1&display=swap');
  :global(body) {
    font-family: 'Montserrat', sans-serif;
    /*padding: 0;*/
    /*margin: 0;*/
    min-height: 100%;
    overflow-x: hidden;
    background: #417374;
  }
</style>
